import { InvoiceComplianceMode } from '@features/invoices/enums/invoiceComplianceMode'
import { getCompanyMissingFields } from '@features/invoices/utils/getCompanyMissingFields'

import type { PredefinedCompanyValues } from '../../types/missingComplianceDetails/predefinedCompanyValues'

interface GetMissingCompanyComplianceDetailsOptions {
  companyValues: PredefinedCompanyValues
  complianceMode: InvoiceComplianceMode
  isVatExempted: boolean
}

interface MissingCompanyComplianceDetails {
  isMissingCompanyAddress: boolean
  isMissingCompanyDetails: boolean
  isMissingCompanyPaymentInfo: boolean
  isMissingCompanyTaxInfo: boolean
  isMissingLegalInfo: boolean
  isMissingLegalStatus: boolean
  isMissingSharedCapital: boolean
}

export const getMissingCompanyComplianceDetails = ({
  companyValues,
  complianceMode,
  isVatExempted,
}: GetMissingCompanyComplianceDetailsOptions): MissingCompanyComplianceDetails => {
  const {
    companyAddress,
    companyCity,
    companyZipCode,
    countryId,
    isSiretPendingAssignment,
    legalStatus,
    sharedCapital,
    iban,
    registrationNo,
    vatNo,
  } = companyValues || {}

  const {
    isMissingAddress,
    isMissingDetails,
    isMissingPaymentInfo,
    isMissingTaxInfo,
    isMissingLegalInfo,
    isMissingLegalStatus,
    isMissingSharedCapital,
  } = getCompanyMissingFields({
    city: companyCity,
    complianceMode,
    countryId,
    iban,
    isSiretPendingAssignment,
    isVatExempted,
    legalStatus,
    registrationNo,
    sharedCapital,
    street: companyAddress,
    vatNo,
    zipCode: companyZipCode,
  })

  return {
    isMissingCompanyAddress: isMissingAddress,
    isMissingCompanyDetails: isMissingDetails,
    isMissingCompanyPaymentInfo: isMissingPaymentInfo,
    isMissingCompanyTaxInfo: isMissingTaxInfo,
    isMissingLegalInfo,
    isMissingLegalStatus,
    isMissingSharedCapital,
  }
}
